import React, { CSSProperties } from 'react'
import { hasPermission } from 'services/permission'
import { Icon } from 'antd'
interface IProps {
	width?: number
	type?: 'primary' | 'default' | 'dangerous'
	title: string
	leftIcon?: string
	leftIconStyle?: CSSProperties
	rightIcon?: string
	rightIconStyle?: CSSProperties
}

interface IActionProps {
	actionCode?: string
	action?: (data: any) => void
	title: string
}

export default class AppMultAction extends React.Component<IProps> {
	state = { show: false }
	static Item: React.FC<IActionProps> = props => {
		if (!hasPermission(props.actionCode)) return <React.Fragment />
		return (
			<div className="app-multli-menu-item no-selected" onClick={props.action}>
				{props.title}
			</div>
		)
		// return <li onClick={props.action}>{props.title}</li>
	}
	chgShow = (e: any) => {
		this.setState({ show: !this.state.show })
		e.nativeEvent.stopImmediatePropagation()
		e.stopPropagation()
		document.onclick = () => {
			this.setState({ show: false })
			document.onclick = null
		}
	}
	getIcon = (icon: React.ReactNode, iconStyle?: CSSProperties): React.ReactNode => {
		if (typeof icon === 'string' && icon.indexOf('http') === 0) {
			return <img src={icon} alt="icon" className={`icon sider-menu-item-img`} />
		}
		if (typeof icon === 'string') {
			if (icon.startsWith('qcciconfont')) {
				return <i className={`app-multli-icon ${icon}`} style={iconStyle} />
			}
			return <Icon type={icon} className="app-multli-icon" style={iconStyle} />
		}
		return icon
	}
	render() {
		return (
			<div
				className="app-multli-action"
				data-type={this.props.type || 'default'}
				style={{ minWidth: '50px' }}
				onClick={e => this.chgShow(e)}
			>
				{this.getIcon(this.props.leftIcon, this.props.leftIconStyle)}
				<div className="app-multli-text">{this.props.title}</div>
				{this.getIcon(this.props.rightIcon, this.props.rightIconStyle)}
				{/* <Icon type="down" className="app-multli-icon" /> */}
				<div className={`app-multli-menu ${this.state.show ? 'show' : 'hidden'}`}>{this.props.children}</div>
				{/* <ul className="app-action-ul" style={{ position: 'absolute' }}>
					<li className="app-action-multli">
						<ul className="app-action-multul"></ul>
					</li>
				</ul> */}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppAction/AppMultAction.tsx